/* eslint-disable @typescript-eslint/no-use-before-define */
import { GuardInput, ForManagingAccount } from 'core'
import { createState } from 'shared'

const firstNameStateContainer = createState('')
export const firstNameState = firstNameStateContainer.state

const lastNameStateContainer = createState('')
export const lastNameState = lastNameStateContainer.state

const usernameStateContainer = createState('')
export const usernameState = usernameStateContainer.state

const formErrorsStateContainer = createState<
	Record<string, string | undefined>
>({})
export const formErrors = formErrorsStateContainer.state

export const setFirstName = (firstNameValue: string) => {
	if (firstNameValue === '') {
		setFormErrors('firstName', '')
		lastNameStateContainer.updateState(() => firstNameValue)
		return
	}

	const firstNameErrorField = GuardInput.check(
		ForManagingAccount.Profile.partial(),
		{
			firstName: firstNameValue
		}
	)

	if (firstNameErrorField) {
		setFormErrors('firstName', firstNameErrorField.inputErrors!.firstName)
	} else {
		setFormErrors('firstName', '')
	}

	firstNameStateContainer.updateState(() => firstNameValue)
}

export const setLastName = (lastNameValue: string) => {
	if (lastNameValue === '') {
		setFormErrors('lastName', '')
		lastNameStateContainer.updateState(() => lastNameValue)
		return
	}

	const lastNameErrorField = GuardInput.check(
		ForManagingAccount.Profile.partial(),
		{
			lastName: lastNameValue
		}
	)

	if (lastNameErrorField) {
		setFormErrors('lastName', lastNameErrorField.inputErrors!.lastName)
	} else {
		setFormErrors('lastName', '')
	}

	lastNameStateContainer.updateState(() => lastNameValue)
}

export const setUsername = (usernameValue: string) => {
	const usernameErrorField = GuardInput.check(
		ForManagingAccount.Profile.partial(),
		{
			handler: usernameValue
		}
	)

	if (usernameErrorField) {
		setFormErrors('username', usernameErrorField.inputErrors!.handler)
	} else {
		setFormErrors('username', '')
	}

	usernameStateContainer.updateState(() => usernameValue)
}

const setFormErrors = (field: string, error?: string) => {
	formErrorsStateContainer.updateState(prevErrorState => {
		if (prevErrorState[field] === error) return prevErrorState
		return {
			...prevErrorState,
			[field]: error
		}
	})
}

export const resetStateValues = () => {
	firstNameStateContainer.updateState(() => '')
	lastNameStateContainer.updateState(() => '')
	usernameStateContainer.updateState(() => '')
	formErrorsStateContainer.updateState(() => ({}))
}
